import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ScrollableDialog from './ScrollableDialog';

const FullImageDialog = ({
  open,
  imageUrl,
  alt = '',
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <ScrollableDialog
      open={Boolean(open && imageUrl)}
      onClose={onClose}
      maxWidth="md"
      title={t('common.viewImage')}
      dividers
      showCloseButton
      titleSx={{ pb: 1, flexShrink: 0 }}
    >
      <Box
        component="img"
        src={imageUrl}
        alt={alt}
        sx={{
          display: 'block',
          width: '100%',
          maxHeight: { xs: '70vh', md: '80vh' },
          objectFit: 'contain',
          borderRadius: 1,
        }}
      />
    </ScrollableDialog>
  );
};

export default FullImageDialog;
